import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CertificacionCpeViewModel, SolicitudCpeCertificacionViewModel } from './certificacion.types';



@Injectable()
export class CertificacionService {

   
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {


    }    

    getSolicitudCpeCertificacion(id: number): Observable<SolicitudCpeCertificacionViewModel> {
        return this.http
            .get<SolicitudCpeCertificacionViewModel>(this.baseUrl + 'api/exportacion/cpes/certificacionCpe/' + id).pipe();
    }

    //getCertificacionCpe(id: number): Observable<CertificacionCpeViewModel> {
    //    return this.http
    //        .get<CertificacionCpeViewModel>(this.baseUrl + 'api/exportacion/cpes/certificacionCpe/' + id).pipe();
    //}

    editSolicitudCpeCertificacion(solicitudCpeCertificacion: SolicitudCpeCertificacionViewModel): Observable<any> {
        return this.http
            .put<SolicitudCpeCertificacionViewModel>(this.baseUrl + 'api/exportacion/cpes/certificacionCpe', solicitudCpeCertificacion).pipe();
    }

    revisionSolicitante(params: HttpParams): Observable<any> {
        return this.http
            .get<any>(this.baseUrl + 'api/exportacion/cpes/certificacionCpe/RevisionSolicitante/', { params: params }).pipe();
    }
   
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            //this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

   
    
}
